
export const calculateTotalSent = (dailyData = []) => {
    return dailyData.reduce((sum, day) => sum + (day.sent || 0), 0);
};

export const calculateTotalAttempted = (dailyData = []) => {
    return dailyData.reduce((sum, day) => sum + (day.attempted || 0), 0);
};

export const calculateTotalDelivered = (dailyData = []) => {
    return dailyData.reduce((sum, day) => sum + (day.delivered || 0), 0);
};

export const calculateTotalRead = (dailyData = []) => {
    return dailyData.reduce((sum, day) => sum + (day.read || 0), 0);
};

export const calculateTotalFailed = (dailyData = []) => {
    return dailyData.reduce((sum, day) => sum + (day.failed || 0), 0);
};

export const calculateDeliveryRate = (delivered, sent, decimals = 1) => {
    if (sent <= 0) return "0";
    return ((delivered / sent) * 100).toFixed(decimals);
};

export const calculateAllMetrics = (dailyData = [], decimals = 1) => {
    const totalSent = calculateTotalSent(dailyData);
    const totalAttempted = calculateTotalAttempted(dailyData);
    const totalDelivered = calculateTotalDelivered(dailyData);
    const totalRead = calculateTotalRead(dailyData);
    const totalFailed = calculateTotalFailed(dailyData);
    const deliveryRate = calculateDeliveryRate(totalDelivered, totalSent, decimals);

    return {
        totalAttempted,
        totalSent,
        totalDelivered,
        totalRead,
        totalFailed,
        deliveryRate,
    };
};

export const getFormattedMetrics = (dailyData = [], decimals = 2) => {
    const metrics = calculateAllMetrics(dailyData, decimals);
    return {
        ...metrics,
        totalAttemptedFormatted: metrics.totalAttempted.toLocaleString(),
        totalSentFormatted: metrics.totalSent.toLocaleString(),
        totalDeliveredFormatted: metrics.totalDelivered.toLocaleString(),
        totalReadFormatted: metrics.totalRead.toLocaleString(),
        totalFailedFormatted: metrics.totalFailed.toLocaleString(),
        deliveryRateFormatted: `${metrics.deliveryRate}%`,
    };
};
